<template>
  <el-menu
    class="el-menu-vertical-demo"
    active-text-color="#ffd04b"
    background-color="#545c64"
    :default-active="defaultActive"
    text-color="#fff"
    unique-opened
    router
    :collapse="sidebar.opened"
    style="text-align: left;"
  >
    <div class="logo" style="height: 50px">
      <!-- <img :src="logoUrl" alt="" /> -->
      <span>老干部信息服务管理</span>
    </div>
    <!-- <template v-for="(item, index) in this.$router.options.routes"> -->
    <template v-for="(item, index) in menus">
      <!-- 菜单结构 -->
      <el-submenu v-if="!item.hidden == true" :key="index" :index="index + ''">
        <!-- 一级菜单标题 -->
        <template #title>
          <font-awesome-icon
            :icon="item.iconcls"
            style="margin-right: 15px"
          ></font-awesome-icon>
          <span>{{ item.name }}</span>
        </template>

        <el-menu-item
          v-for="(children, idx) in item.children"
          :index="children.path"
          :key="idx"
          >{{ children.name }}</el-menu-item
        >
      </el-submenu>
    </template>
  </el-menu>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  data() {
    return {
      logoUrl: require("@/assets/logo.png"),
    };
  },
  computed: {
    ...mapGetters(["sidebar", "menus"]),

    // 获取第一个字节点
    defaultActive() {
      for (var menu of this.menus) {
        if (menu.children && menu.children.length > 0) {
          return menu.children[0].path;
        }
      }
      return "0";
    },
  },

  mounted() {
    this.activeMenu();
  },
  watch: {
    menus() {
      this.activeMenu();
    },
  },

  methods: {
    activeMenu() {
      for (var menu of this.menus) {
        if (menu.children && menu.children.length > 0) {
          this.$router.push(menu.children[0].path);
          return;
        }
      }
    },
  },
};
</script>

<style>
.logo {
  height: 50px;
  color: white;
  font-weight: bolder;
  display: flex;
  justify-content: center;
}
.logo img {
  height: 30px;
  width: 30px;
}
.el-menu--collapse .logo span {
  display: none;
}
</style>

